type ChoiceFieldElement = {
  dataType?: string;
  enableCalculations?: boolean;
  calculatedOptions?: unknown;
  [key: string]: unknown;
};

type Slide<ElementType extends ChoiceFieldElement = ChoiceFieldElement> = {
  slideData?: ElementType[];
  [key: string]: unknown;
};

const CALCULATED_OPTION_CHOICE_TYPES = new Set(["RADIO", "CHECKBOX"]);

const shouldRemoveCalculatedOptions = (element: ChoiceFieldElement) =>
  CALCULATED_OPTION_CHOICE_TYPES.has(element?.dataType ?? "") &&
  !element?.enableCalculations;

export const sanitizeChoiceFieldCalculatedOptionsForSave = <
  ElementType extends ChoiceFieldElement
>(
  elements: ElementType[] = []
): ElementType[] =>
  elements.map((element) => {
    if (!shouldRemoveCalculatedOptions(element)) {
      return element;
    }

    const { calculatedOptions: _calculatedOptions, ...fieldForSave } = element;
    return fieldForSave as ElementType;
  });

export const sanitizeSlideChoiceFieldCalculatedOptionsForSave = <
  SlideType extends Slide
>(
  slides: SlideType[] = []
): SlideType[] =>
  slides.map((slide) => ({
    ...slide,
    slideData: sanitizeChoiceFieldCalculatedOptionsForSave(
      slide.slideData ?? []
    ),
  }));
